import React from 'react';
import {
  FaCrown,
  FaGem,
  FaShieldAlt,
  FaGavel,
  FaHandsHelping,
  FaCode,
  FaCube,
  FaPalette,
  FaBullhorn,
  FaMagic,
  FaHeadset,
  FaHandshake,
  FaMedal,
  FaStar,
  FaBolt,
  FaHeart,
  FaFire,
  FaRocket,
} from 'react-icons/fa';
import { TEAM_BADGE_BY_ID } from '../../config/teamBadges';
import './TeamBadge.css';

export const TEAM_BADGE_ICON_MAP = {
  crown: FaCrown,
  gem: FaGem,
  shield: FaShieldAlt,
  gavel: FaGavel,
  hand: FaHandsHelping,
  code: FaCode,
  cube: FaCube,
  palette: FaPalette,
  megaphone: FaBullhorn,
  sparkles: FaMagic,
  headset: FaHeadset,
  handshake: FaHandshake,
  medal: FaMedal,
  star: FaStar,
  bolt: FaBolt,
  heart: FaHeart,
  fire: FaFire,
  rocket: FaRocket,
};

/**
 * Badge visual da equipe Nexus.
 * Aceita objeto do catálogo/API ou id string.
 */
export function TeamBadge({ badge, size = 'md', showLabel = true, className = '' }) {
  const resolved =
    typeof badge === 'string'
      ? TEAM_BADGE_BY_ID[badge]
      : badge?.id
        ? { ...(TEAM_BADGE_BY_ID[badge.id] || {}), ...badge }
        : null;

  if (!resolved?.id) return null;

  const Icon = TEAM_BADGE_ICON_MAP[resolved.icon] || FaStar;
  const tone = resolved.tone || 'violet';
  const customColor = resolved.color && /^#([0-9a-fA-F]{6})$/.test(resolved.color)
    ? resolved.color
    : null;

  const style = customColor
    ? {
        '--badge-fg': '#fff',
        '--badge-bg': `${customColor}33`,
        '--badge-border': `${customColor}99`,
        '--badge-glow': `${customColor}88`,
        '--badge-icon': customColor,
      }
    : undefined;

  return (
    <span
      className={`team-badge team-badge--${tone} team-badge--${size}${className ? ` ${className}` : ''}`}
      style={style}
      title={resolved.description || resolved.label}
    >
      <span className="team-badge__glow" aria-hidden="true" />
      <span className="team-badge__icon" aria-hidden="true">
        <Icon />
      </span>
      {showLabel && <span className="team-badge__label">{resolved.label}</span>}
    </span>
  );
}

export function TeamBadgeList({
  badges = [],
  size = 'md',
  showLabel = true,
  className = '',
  empty = null,
}) {
  const list = Array.isArray(badges) ? badges.filter(Boolean) : [];
  if (!list.length) return empty;

  return (
    <div className={`team-badge-list${className ? ` ${className}` : ''}`}>
      {list.map((b) => {
        const id = typeof b === 'string' ? b : b.id;
        return (
          <TeamBadge
            key={id}
            badge={b}
            size={size}
            showLabel={showLabel}
          />
        );
      })}
    </div>
  );
}

export default TeamBadge;
